<template>
  <div id="app">
    <pantalla-carga :is-loading="isLoading" />
    <AppHeader />
    <transition name="fade" mode="out-in">
      <router-view />
    </transition>
    <AppFooter/>
    <div class="contenedor-parriba position-absolute position-fixed" @click="toTop" v-if="boton">
      <i class="fas fa-chevron-up"></i>
    </div>
  </div>
</template>
<script>
import AppHeader from "@/components/layout/cliente/AppHeader.vue";
import AppFooter from "@/components/layout/cliente/AppFooter.vue";
import pantallaCarga from "@/components/cliente/ui/pantallaCarga.vue";
export default {
  name: "App",
  components: {
    AppHeader,
    AppFooter,
    pantallaCarga
  },
  data() {
    return {
      boton: false,
      isLoading: true,
      navtoggle: false,
      navbarbg: false
    };
  },
  created() {
    window.addEventListener("scroll", this.handleScroll);
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  mounted() {
    setTimeout(() => {
      this.isLoading = false;
    }, 2000);
  },

  methods: {
    toTop() {
      window.scrollTo(0, 0);
    },
    handleScroll() {
      //Valor del eje Y del scroll
      var scrollPos = window.scrollY;
      if (scrollPos > 100) {
        this.navbarbg = true;
      } else {
        this.navbarbg = false;
      }
      if (scrollPos > 200) {
        this.boton = true;
      } else {
        this.boton = false;
      }
    }
  }
};
</script>
<style>
@import url("https://fonts.googleapis.com/css?family=Nunito&display=swap");
#app {
  font-family: "Nunito", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  max-width: 100vw;
}

.fade-enter-active,
.fade-leave-active {
  transition-duration: 0.2s;
  transition-property: opacity;
  transition-timing-function: linear;
}

.fade-enter,
.fade-leave-active {
  opacity: 0.8;
}
.contenedor-parriba {
  bottom: 10px;
  right: 10px;
  font-size: 30px;
  color: gray;
}
.contenedor-parriba:hover{
  cursor: pointer;
}
</style>
